const UISettingsPluginSettings: IPluginSettings = {
    name: 'Настройки интерфейса',
    mnemocode: 'ui_settings_plugin',
    permission: 'SysOptions',
    columns: [{
        order: 0,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'ID',
        visibility: false,
        width: 150
    }, {
        order: 1,
        propertyName: 'displayName',
        propertyType: 'string',
        displayName: 'Настройка',
        visibility: true,
        width: 350
    }, {
        order: 2,
        propertyName: 'settingsName',
        propertyType: 'string',
        displayName: 'Код',
        visibility: true,
        width: 350
    }, {
        order: 3,
        propertyName: 'description',
        propertyType: 'string',
        displayName: 'Описание',
        visibility: true,
        width: 350
    }
    ],
}

export default UISettingsPluginSettings
